module.exports = __webpack_public_path__ + "assets/img/solar-panels-11.03d93528.jpg";